function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useContext, useState, useEffect } from 'react';
import cn from 'classnames';
import { string } from 'prop-types';
import PopupContext from '../../context/PopupContext';
import Icon from '../../atoms/Icon';
/**
 * PopupToggleButton component.
 */

var PopupToggleButton = function PopupToggleButton(_ref) {
  var className = _ref.className,
      popup = _ref.popup,
      closeIcon = _ref.closeIcon,
      openIcon = _ref.openIcon;

  var _useContext = useContext(PopupContext),
      activePopup = _useContext.activePopup,
      setActivePopup = _useContext.setActivePopup;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      jsEnabled = _useState2[0],
      setJsEnabled = _useState2[1];

  useEffect(function () {
    setJsEnabled(true);
  });
  var Component = jsEnabled ? 'button' : 'a';
  return /*#__PURE__*/React.createElement(Component, {
    className: cn('popup-toggle-button', className),
    type: jsEnabled ? 'button' : null,
    onClick: function onClick() {
      setActivePopup(activePopup === popup ? null : popup);
    },
    "aria-label": "Toggle ".concat(popup, " popup"),
    "aria-haspopup": "true",
    "aria-expanded": jsEnabled ? (activePopup === popup).toString() : null,
    href: jsEnabled ? null : "#".concat(popup, "-popup")
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 24,
    color: "inherit",
    name: activePopup === popup ? closeIcon : openIcon
  }));
};

PopupToggleButton.defaultProps = {
  className: null
};
PopupToggleButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,

  /** The name of the popup to toggle. */
  popup: string.isRequired,

  /** The name of the open icon. */
  openIcon: string.isRequired,

  /** The name of the close icon. */
  closeIcon: string.isRequired
} : {};
export default PopupToggleButton;